import { render } from "./app-layout.vue?vue&type=template&id=59372e38"
import script from "./app-layout.vue?vue&type=script&lang=js"
export * from "./app-layout.vue?vue&type=script&lang=js"

import "./app-layout.vue?vue&type=style&index=0&id=59372e38&lang=scss"
script.render = render

export default script